// UNUSED
import React, { useEffect, useMemo } from 'react'
import { Box, Typography, CircularProgress } from '@mui/material'
import { useOutletContext } from 'react-router-dom'

import WizardContainer from './shared/WizardContainer'
import WizardFooter from './shared/WizardFooter'

import useNextSteps from '../hooks/api/useNextSteps'
import { NextStepsForm } from '../settings/NextSteps'
import useAlert from '../hooks/useAlert'
import GenericLoadError from '../common/GenericLoadError'

const ActionTypes = () => {
  const {
    navigateToNext,
    setCompanyConfig,
    companyConfig,
    updateCompanyConfig,
    wizardState,
    updateWizardState,
  } = useOutletContext()

  const { nextSteps = [] } = wizardState

  const hasInitializedData = useMemo(() => !!wizardState.nextSteps, [])

  const {
    nextSteps: nextStepsData,
    setNextSteps: setNextStepsData,
    saveNextSteps,
    isLoading,
    hasLoadError,
  } = useNextSteps()

  useEffect(() => {
    if (hasInitializedData) return setNextStepsData(nextSteps)

    if (isLoading) return

    updateWizardState({ nextSteps: nextStepsData })
  }, [isLoading])

  const setNextSteps = (nextSteps) => {
    setNextStepsData(nextSteps)
    updateWizardState({ nextSteps })
  }

  const { createAlert } = useAlert()

  const onSubmit = () => {
    const newConfig = {
      ...companyConfig,
      hasSavedActions: true,
    }

    setCompanyConfig(newConfig)

    updateCompanyConfig(newConfig)
      .then(saveNextSteps)
      .then(() => {
        navigateToNext()
      })
      .catch((e) => {
        createAlert({
          severity: 'error',
          message: 'Something went wrong',
          action: {
            label: 'Skip this step',
            onClick: () => navigateToNext(),
          },
        })
      })
  }

  if (hasLoadError && !hasInitializedData) return <GenericLoadError />

  return (
    <WizardContainer>
      <Typography variant={'h5'}>Next Step Actions</Typography>
      {isLoading && <CircularProgress />}
      <Box sx={{ mb: 2 }}>
        <Typography>
          Here is where you’ll be able to customize the "next step" actions that
          need to be taken once a customer has been added to your system. Below
          are some examples of actions that are standard to most businesses.
        </Typography>
      </Box>

      <NextStepsForm nextSteps={nextSteps} setNextSteps={setNextSteps} />

      <WizardFooter
        primaryButton={{ label: 'Save and continue', onClick: onSubmit }}
      />
    </WizardContainer>
  )
}

export default ActionTypes
